import {
  type ActivityListInput,
  isEmpty,
  type WorkflowId,
  type WorkflowListInput,
  type WorkflowStatsInput,
} from '@terros/common'
import { type QueryKey } from '@tanstack/react-query'

export const workflowKey = (workflowId: WorkflowId): QueryKey => ['workflow-decorated', workflowId]
export const workflowListKey = (input?: WorkflowListInput): QueryKey => {
  if (isEmpty(input)) return ['workflows']
  return ['workflows', input]
}
export const workflowStatsKey = (input: Pick<WorkflowStatsInput, 'workflowId' | 'targetIds'>): QueryKey => [
  'workflow-stats',
  input,
]

export const activityListKey = (props?: ActivityListInput): QueryKey => {
  if (!props) return ['activity']
  return ['activity', props]
}
export const activityInfiniteKey = (props: ActivityListInput): QueryKey => ['activity-infinite', props]
